import React from 'react';
import classnames from 'classnames';
import { useSecurity } from 'sunzi-hooks';
import { s as styleInject } from './style-inject.es-4a6aca40.js';

var css_248z = ".sunzi_components__layout-iYUS2 {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  font-weight: 400;\n  font-family: 'Roboto', sans-serif;\n  line-height: 1.2;\n}\n.sunzi_components__layout-iYUS2 .sunzi_components__plugin-21vLl {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  overflow: hidden;\n}\n@media screen and (min-width: 768px) {\n  .sunzi_components__layout-iYUS2 .sunzi_components__plugin-21vLl {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n    -webkit-justify-content: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    background-color: rgba(0, 0, 0, 0.7);\n  }\n}\n.sunzi_components__layout-iYUS2 * {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n";
var styles = {"layout":"sunzi_components__layout-iYUS2","plugin":"sunzi_components__plugin-21vLl"};
styleInject(css_248z);

var Layout = function (_a) {
  var className = _a.className,
      _b = _a.theme,
      theme = _b === void 0 ? {
    r: 255,
    g: 83,
    b: 58
  } : _b,
      children = _a.children;
  var security = useSecurity();
  var themeColor = "\n    :root {\n      --sunzi-theme-color: rgba(" + theme.r + ", " + theme.g + ", " + theme.b + ");\n      " + Array.from({
    length: 8
  }).map(function (_, index) {
    return "--sunzi-theme-color-o" + (index + 1) + ": rgba(" + theme.r + ", " + theme.g + ", " + theme.b + ", ." + (index + 1) + ")";
  }).join(';') + "\n    }";
  return React.createElement("div", {
    className: classnames(styles.layout, className)
  }, React.createElement("style", null, themeColor), security && children);
};

export default Layout;
